import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DataDetailsTable from '../../../../../../components/details-table/DataDetailsTable';
import { Accordion, AccordionDetails, AccordionSummary } from '@biq/apex-ui';
import { GeneralDetailsAccordionProps } from './general-details-accordion-helpers';
import { EmptyStateDrawerDetails } from 'components';

const GeneralDetailAccordion = ({
    expanded,
    onChange,
    accordionAriaControls,
    accordionSumID,
    accordionHeader,
    data,
}: GeneralDetailsAccordionProps): React.JSX.Element => {
    return (
        <Accordion expanded={expanded} onChange={onChange} variant='outlined'>
            <AccordionSummary
                aria-controls={accordionAriaControls}
                id={accordionSumID}
                expandIcon={<ExpandMoreIcon />}
                header={accordionHeader}
            />
            {data ? (
                <AccordionDetails>
                    <DataDetailsTable data={data} />
                </AccordionDetails>
            ) : (
                <EmptyStateDrawerDetails />
            )}
        </Accordion>
    );
};

export default GeneralDetailAccordion;
